import { NotificationType } from './notification-type';

export interface Notification {
    id: number;
    type: NotificationType;
    params: Record<string, unknown>;
    createdAt: string;
    read: boolean;
}
